









import { Vue, Component } from 'vue-property-decorator'
import { ISnackbar } from '@models';

@Component
export default class Snackbar extends Vue {
  name = 'snackbar';
  snackbar: ISnackbar = {
    visible: false,
    message: '',
    color: '',
    timeout: 5000
  };

  created() {
    addEventListener('snackbar', this.showsnackbar);
  }

  showsnackbar(event) {
    this.snackbar.message = event.detail.message;
    this.snackbar.color = event.detail.color;
    this.snackbar.visible = true;
    if (event.detail.sticky) {
      this.snackbar.timeout = 0;
    } else {
      this.snackbar.timeout = 5000;
    };
  }
}

